import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { MaintenanceWorkComponent } from './pages/maintenance-work/maintenance-work.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { HeaderNoLoginComponent } from './components/no-login/header-no-login/header-no-login.component';
import { FooterComponent } from './components/footer/footer.component';
import { SidenavNoLoginComponent } from './components/no-login/sidenav-no-login/sidenav-no-login.component';
import { LinkListPipe } from './pipes/link-list/link-list.pipe';
import { NoMobileComponent } from './pages/no-mobile/no-mobile.component';
import { BlankNoLoginComponent } from './components/no-login/blank-no-login/blank-no-login.component';
import { FieldItemTextComponent } from './components/field-item/text/text.component';
import { FieldItemEmailComponent } from './components/field-item/email/email.component';
import { FieldItemTextInputComponent } from './components/field-item/text-input/text-input.component';
import { FieldItemDividerComponent } from './components/field-item/divider/divider.component';
import { FieldItemTitleSecondComponent } from './components/field-item/title-second/title-second.component';
import { FieldItemTitleOneComponent } from './components/field-item/title-one/title-one.component';
import { FieldItemDateComponent } from './components/field-item/date/date.component';
import { FieldItemTextareaComponent } from './components/field-item/textarea/textarea.component';
import { FieldItemNumberComponent } from './components/field-item/number/number.component';
import { FieldItemCheckboxComponent } from './components/field-item/checkbox/checkbox.component';
import { FieldItemRadioComponent } from './components/field-item/radio/radio.component';
import { FieldItemCombofieldComponent } from './components/field-item/combofield/combofield.component';
import { FieldItemToggleComponent } from './components/field-item/toggle/toggle.component';
import { FieldItemRatingComponent } from './components/field-item/rating/rating.component';
import { FieldItemDownloadButtonComponent } from './components/field-item/download-button/download-button.component';
import { FieldItemLinkButtonComponent } from './components/field-item/link-button/link-button.component';
import { FieldItemAllToggleFunctionComponent } from './components/field-item/all-toggle-function/all-toggle-function.component';
import { FieldItemLegendComponent } from './components/field-item/legend/legend.component';
import { FieldItemAutocomplete } from './components/field-item/autocomplete/autocomplete.component';
import { GetMaxPipe } from './components/field-item/rating/get-max.pipe';
import { ErrorMessagesService } from './services/errorMessages/error-messages.service';
import { FieldItemImgTextComponent } from './components/field-item/img-text/img-text.component';
import { LeftLogoComponent } from './components/logo/left-logo/left-logo.component';
import { RightLogoComponent } from './components/logo/right-logo/right-logo.component';
import { BankLogoDefaultComponent } from './components/logo/bank-logo-default/bank-logo-default.component';
import { ActionLogoComponent } from './components/logo/action-logo/action-logo.component';
import { PosAndColorPipe } from './pipes/field-item/pos-and-color/pos-and-color.pipe';
import { NavListCSVComponent } from './components/nav-list/csv/csv-list.component';
import { NavListComponent } from './components/nav-list/nav-list/nav-list.component';
import { NavListSpecialComponent } from './components/nav-list/special-list/special-list.component';
import { SetClassUrlDirective } from './directives/set-class-url.directive';
import { FileuploadModule } from './components/fileupload/fileupload.module'
import { RouterModule } from '@angular/router';
import { SanitizerTrustUrlPipe } from './pipes/sanitizer-trust-url/sanitizer-trust-url.pipe';
import { SanitizerHtmlPipe } from './pipes/sanitizer-html/sanitizer-html.pipe';
import {AppearencePipe} from '../project/pipes/appearence/appearence.pipe';
import {MaxFieldWidthPipe} from '../project/pipes/max-field-width.pipe';
import {FieldItemFileuploadButtonComponent} from './components/field-item/fileupload-button/fileupload-button.component';
import {FieldItemDialoFileUploadComponent} from './dialogs/fileupload/dialog-fileupload.component';

@NgModule({
   declarations: [
      HeaderNoLoginComponent,
      FooterComponent,
      MaintenanceWorkComponent,
      NotFoundComponent,
      SpinnerComponent,
      BlankNoLoginComponent,
      SidenavNoLoginComponent,
      LinkListPipe,
      BankLogoDefaultComponent,
      ActionLogoComponent,
      NoMobileComponent,
      FieldItemTextComponent,
      FieldItemEmailComponent,
      FieldItemTextInputComponent,
      FieldItemDividerComponent,
      FieldItemTitleSecondComponent,
      FieldItemTitleOneComponent,
      FieldItemDateComponent,
      FieldItemTextareaComponent,
      FieldItemNumberComponent,
      FieldItemCheckboxComponent,
      FieldItemRadioComponent,
      FieldItemCombofieldComponent,
      FieldItemToggleComponent,
      FieldItemRatingComponent,
      FieldItemDownloadButtonComponent,
      FieldItemLinkButtonComponent,
      FieldItemAllToggleFunctionComponent,
      FieldItemLegendComponent,
      FieldItemImgTextComponent,
      FieldItemFileuploadButtonComponent,
      FieldItemAutocomplete,
      FieldItemDialoFileUploadComponent,
      GetMaxPipe,
      LeftLogoComponent,
      RightLogoComponent,
      NavListCSVComponent,
      NavListComponent,
      NavListSpecialComponent,
      SetClassUrlDirective,
      SanitizerTrustUrlPipe,
      SanitizerHtmlPipe
   ],
   imports: [
      RouterModule.forChild([]),
      CommonModule,
      MaterialModule,
      ReactiveFormsModule,
      FormsModule, 
      PosAndColorPipe,
      TranslateModule,
      FileuploadModule,
      MaxFieldWidthPipe
   ],
   providers: [
      ErrorMessagesService,
      LinkListPipe,
      SanitizerTrustUrlPipe,
      SanitizerHtmlPipe
   ],
   exports: [
      FormsModule, 
      FileuploadModule,
      MaterialModule,
      HeaderNoLoginComponent,
      FooterComponent,
      MaintenanceWorkComponent,
      NotFoundComponent,
      SpinnerComponent,
      BlankNoLoginComponent,
      SidenavNoLoginComponent,
      LinkListPipe,
      BankLogoDefaultComponent,
      ActionLogoComponent,
      NoMobileComponent,
      FieldItemTextComponent,
      FieldItemEmailComponent,
      FieldItemTextInputComponent,
      FieldItemDividerComponent,
      FieldItemTitleSecondComponent,
      FieldItemTitleOneComponent,
      FieldItemDateComponent,
      FieldItemTextareaComponent,
      FieldItemNumberComponent,
      FieldItemCheckboxComponent,
      FieldItemRadioComponent,
      FieldItemCombofieldComponent,
      FieldItemToggleComponent,
      FieldItemRatingComponent,
      FieldItemDownloadButtonComponent,
      FieldItemLinkButtonComponent,
      FieldItemAllToggleFunctionComponent,
      FieldItemLegendComponent,
      FieldItemImgTextComponent,
      FieldItemFileuploadButtonComponent,
      FieldItemAutocomplete,
      FieldItemDialoFileUploadComponent,
      NavListCSVComponent,
      NavListSpecialComponent,
      SetClassUrlDirective,
      SanitizerTrustUrlPipe,
      SanitizerHtmlPipe
   ],  
   schemas: [],
})
export class SharedModule {}
